const map = {
	"./AmpliTeach_white.png": 33091,
	"./Ic_practice time.svg": 62556,
	"./Singing Teacher-595b40b75ba036ed117d8efe 1.svg": 74805,
	"./ampliTeach.svg": 84945,
	"./arrow_down_black.svg": 76341,
	"./arrow_right_white.svg": 8203,
	"./assign_practice.svg": 6152,
	"./attachment.svg": 86796,
	"./attendance_icon.svg": 94542,
	"./audio_bg.svg": 60907,
	"./audio_play.svg": 27960,
	"./backward_btn_icon.svg": 2451,
	"./bars-progress-solid.svg": 97281,
	"./book_open.svg": 15983,
	"./build_my_biz_icon.svg": 53824,
	"./calender_icon.svg": 45507,
	"./call_icon_white.svg": 73979,
	"./cart_icon.svg": 80823,
	"./category.svg": 67551,
	"./check-solid.svg": 16959,
	"./choose_from_library.svg": 38839,
	"./communication_log_icon.svg": 42098,
	"./complete_Practice.svg": 20142,
	"./course_img_i.jpg": 66456,
	"./course_img_ii.jpg": 92887,
	"./courses_graphic.png": 52860,
	"./create_course_lesson.svg": 30596,
	"./crossIcon.png": 50656,
	"./csv_icon.svg": 48223,
	"./dashboard_icon_red.svg": 92915,
	"./dashboard_icon_white.svg": 80901,
	"./data_not_found.svg": 3924,
	"./delete.svg": 10154,
	"./delete_white.svg": 56972,
	"./doc.svg": 5227,
	"./download.png": 25651,
	"./download_red.svg": 99407,
	"./download_white.png": 57129,
	"./dummy.pdf": 85793,
	"./empty_cart.svg": 93675,
	"./file_example_MP4_480_1_5MG.mp4": 50180,
	"./grid_black_icon.svg": 81949,
	"./grid_red_icon.svg": 17817,
	"./group_icon.png": 76060,
	"./help_icon.svg": 34750,
	"./ic_View_schedule.svg": 69707,
	"./ic_access_practice.svg": 57452,
	"./ic_message.svg": 18963,
	"./icon_add_file_links.jpg": 41109,
	"./icon_audio_pause.svg": 99848,
	"./icon_audio_play.svg": 79200,
	"./icon_calendar.svg": 52809,
	"./icon_choose_file.jpg": 77997,
	"./icon_clock.svg": 267,
	"./icon_clock_black.svg": 73983,
	"./icon_cross_white.svg": 47263,
	"./icon_date_black.png": 65477,
	"./icon_date_red.png": 37077,
	"./icon_date_red.svg": 85511,
	"./icon_date_white.png": 94575,
	"./icon_document.svg": 83960,
	"./icon_dots_vertical.svg": 31836,
	"./icon_guitar.svg": 70337,
	"./icon_monthly_black.png": 88846,
	"./icon_monthly_white.png": 30704,
	"./icon_mp3.svg": 89047,
	"./icon_payment.svg": 10159,
	"./icon_pdf.svg": 13395,
	"./icon_select_course.jpg": 9629,
	"./icon_teacher.svg": 36235,
	"./icon_timer_pause.svg": 22105,
	"./icon_timer_play.svg": 92355,
	"./icon_timer_stop.svg": 4889,
	"./icon_week_black.png": 61709,
	"./icon_week_red.svg": 9923,
	"./icon_week_white.png": 95671,
	"./icon_youtube.jpg": 40618,
	"./image.svg": 26794,
	"./image_upload.svg": 55186,
	"./inner_profile_pic.png": 90936,
	"./intstrument.jpg": 41426,
	"./invalid_icon.svg": 41940,
	"./invite.svg": 54180,
	"./invoice_bottom_left_red_bg.svg": 73276,
	"./invoice_top_right_red_bg.svg": 75955,
	"./learning_icon_red.svg": 65739,
	"./learning_icon_white.svg": 64029,
	"./list_black_icon.svg": 50749,
	"./list_red_icon.svg": 47417,
	"./login_bg_left.svg": 79860,
	"./login_bg_right.svg": 37627,
	"./login_desc_bg.jpg": 84750,
	"./login_widget_vector.svg": 21617,
	"./mail_icon_white.svg": 71604,
	"./member-1.png": 15607,
	"./member-2.png": 91676,
	"./member-3.png": 43941,
	"./member-4.png": 73514,
	"./members_icon_red.svg": 63504,
	"./members_icon_white.svg": 18574,
	"./message_icon.svg": 42056,
	"./minus.svg": 16993,
	"./modal_cross_icon.svg": 96657,
	"./modal_cross_icon_gray.svg": 489,
	"./modal_cross_icon_white.svg": 99627,
	"./msg_read_dtick.png": 35323,
	"./musical-note-variant-with-thin-outline-svgrepo-com.svg": 51915,
	"./no_course_for_approval.svg": 20408,
	"./no_data_found_calander.svg": 22613,
	"./no_notification_image.svg": 12106,
	"./notification_blank_icon.svg": 6151,
	"./notification_icon.svg": 33922,
	"./notification_icon_white.svg": 89108,
	"./order_1.png": 27151,
	"./order_2.png": 8244,
	"./order_3.png": 29373,
	"./order_4.png": 33026,
	"./payments_icon.svg": 410,
	"./payroll_icon.svg": 25822,
	"./pdf.svg": 2443,
	"./pdf_icon.svg": 47637,
	"./play_arrow.png": 97823,
	"./practice_video_icon.svg": 68696,
	"./profile_pic.png": 29057,
	"./progressbar_rounded_green.svg": 69875,
	"./progressbar_rounded_red.svg": 74495,
	"./question-sign-in-circles-svgrepo-com.svg": 45772,
	"./question-svgrepo-com.svg": 88374,
	"./recent_activity_1.jpg": 25868,
	"./recent_activity_2.jpg": 86491,
	"./recent_activity_3.jpg": 1534,
	"./recent_activity_4.jpg": 48869,
	"./recent_activity_5.jpg": 4904,
	"./reporting_graphic.png": 37984,
	"./reporting_icon_red.svg": 77949,
	"./reporting_icon_white.svg": 45087,
	"./schedualing_icon_red.svg": 45702,
	"./schedualing_icon_white.svg": 18996,
	"./school_icon.svg": 97929,
	"./search_icon.svg": 76185,
	"./select.png": 51347,
	"./select_down_arrow.svg": 60132,
	"./send.svg": 54505,
	"./setting.svg": 34621,
	"./smile.svg": 89505,
	"./sms_icon_white.svg": 86864,
	"./store_icon.svg": 97442,
	"./store_loader_icon.svg": 2524,
	"./stud_billing_icon_red.svg": 88079,
	"./stud_billing_icon_white.svg": 97353,
	"./student_myFavourite.svg": 21862,
	"./student_practice_assigned.svg": 55987,
	"./student_profile_pic.png": 19149,
	"./student_report_icon.svg": 68003,
	"./students_graphic.png": 32770,
	"./success_true_tick.svg": 11597,
	"./support_graphic.png": 35167,
	"./support_icon.svg": 11220,
	"./system_drop_down_list.svg": 89562,
	"./teacher_dashboard_banner_vector.svg": 24971,
	"./teacher_report.svg": 87976,
	"./teachers_graphic.png": 80471,
	"./teachers_profile_pic.png": 57329,
	"./thumbnail.jpg": 88311,
	"./triangle-exclamation-solid.svg": 1557,
	"./true_tick.svg": 23709,
	"./two_arrows.svg": 66680,
	"./upload.png": 82456,
	"./waving-hand.png": 67683,
	"./welcome_chat_bg.png": 46010,
	"./welcome_graphic.png": 25486,
	"./word_icon.svg": 39661,
	"./xmark-solid.svg": 91056,
	"./youtube.svg": 36046
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;